










import Vue from "vue";
import { mapState } from "vuex";
import LocationSwitcher from "@/components/LocationSwitcher.vue";

export default Vue.extend({
  components: {
    LocationSwitcher,
  },
  props: {
    isDisabled: Boolean,
  },
  computed: {
    ...mapState({
      locations: (state: any) => state.company.locations,
      locationId: (state: any) => state.company.locationDetail.id,
    }),
    activeLocations() {
      return this.locations.filter((loc: any) => loc.active !== false);
    },
  },
});
